module.exports = __webpack_public_path__ + "static/pic08-3846331b4e2ec02a00b83ac5f4d0fb8a.jpg";